import React, { createContext } from "react";

export const EditGroupViewContext = createContext();

export const EditGroupViewContextProvider = ({ children, watch }) => {
  const GroupViewContextConstants = watch();
  return (
    <EditGroupViewContext.Provider value={GroupViewContextConstants}>
      {children}
    </EditGroupViewContext.Provider>
  );
};
